/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.network.di

import kpt.core.base.network.restApi
import kpt.core.base.network.supabaseApi
import kpt.core.network.coingecko.api.createCoinGeckoApi
import kpt.core.network.fineract.api.createFineractApi
import kpt.core.network.frankfurter.api.createFrankfurterApi
import kpt.core.network.fred.api.createFredApi
import kpt.core.network.jsonplaceholder.api.createJsonPlaceholderApi
import kpt.core.network.lwmswhoxvvoagzkqxiyd.appserverconfig.api.ServerInstanceApi
import kpt.core.network.lwmswhoxvvoagzkqxiyd.appserverconfig.api.impl.ServerInstanceApiImpl
import kpt.core.network.worldbank.api.createWorldBankApi
import org.koin.core.module.Module
import org.koin.dsl.module

/**
 * GENERATED from `@ApiBinding` — one Koin binding per bound access point. DO NOT HAND-EDIT.
 *
 * To add an API: declare the endpoint in `app-profile/app.yaml#network.access_points`
 * (its URL, kind and owner are deployment config, not a property of the class), then write
 * the API type and annotate it `@ApiBinding("<id>")`. There is no wiring step.
 *
 * 6 REST + 1 Supabase binding(s).
 *
 * Pulled in by `NetworkModule` via `includes(GeneratedApiBindings)`.
 */
val GeneratedApiBindings: Module = module {
    supabaseApi<ServerInstanceApi>("lwmswhoxvvoagzkqxiyd") { ServerInstanceApiImpl(it) }
    restApi("jsonplaceholder") { it.createJsonPlaceholderApi() }
    restApi("frankfurter") { it.createFrankfurterApi() }
    restApi("coingecko") { it.createCoinGeckoApi() }
    restApi("fred") { it.createFredApi() }
    restApi("fineract") { it.createFineractApi() }
    restApi("worldbank") { it.createWorldBankApi() }
}
